import moment from 'moment';
import classNames from 'classnames/bind';
import { useSelector } from 'react-redux';

import CusButton from '../CusButton';
import { convertCurrency } from '~/configs';
import styles from './ResultPayment.module.scss';
import imageWarning from '../../assets/image/warning.png';
import imageSuccess from '../../assets/image/success.png';

const cx = classNames.bind(styles);

function ResultPayment({ handlePaymentBack, refs = '/app' }) {
    const { currentUser } = useSelector((state) => state.auth);
    const { paymentSelected, awardSelected } = useSelector((state) => state.payment);

    return (
        <div className={cx('wrapper')}>
            <div className={cx('alert')}>
                <div className={cx('icon')} style={{ backgroundImage: `url(${refs === '/billing' ? imageSuccess : imageWarning})` }}></div>
                <span className={cx('title')}>{refs === '/billing' ? 'Xin chúc mừng!' : 'Đang xử lý!'}</span>
            </div>

            <div className={cx('content')}>
                <div className={cx('notify')}>{refs === '/billing' ? 'Giao dịch thành công' : 'Đang được xử lý!'}</div>

                <div className={cx('item')}>
                    <div className={cx('product')}>Sản phẩm được chọn</div>
                    <div className={cx('value')}>
                        <img
                            src={
                                awardSelected.type === 'award'
                                    ? currentUser.app.bonus_icon
                                    : awardSelected.type === 'membership'
                                    ? awardSelected.bonus_icon
                                    : ''
                            }
                            alt={currentUser.app.title}
                        />
                        <span>{awardSelected.title}</span>
                    </div>
                </div>
                <div className={cx('item')}>
                    <div className={cx('product')}>Giá</div>
                    <div className={cx('value')}>{convertCurrency(awardSelected.amount.value)}</div>
                </div>
                <div className={cx('item')}>
                    <div className={cx('product')}>Phương thức thanh toán</div>
                    <div className={cx('value')}>{paymentSelected.title}</div>
                </div>
                <div className={cx('item')}>
                    <div className={cx('product')}>Thời gian giao dịch</div>
                    <div className={cx('value')}>{moment(new Date()).format('HH:mm:ss DD/MM/YYYY')}</div>
                </div>
                <div className={cx('item')}>
                    <div className={cx('product')}>ID giao dịch</div>
                    <div className={cx('value')}>{Math.floor(Math.random() * 99999999999999999) + 1}</div>
                </div>

                <div className={cx('btn')}>
                    <CusButton onClick={handlePaymentBack} text="Thanh toán lại" />
                </div>
            </div>
        </div>
    );
}

export default ResultPayment;
